import { action } from 'satcheljs';

export const onAuthPageInitialized = action('onAuthPageInitialized', (loginHint?: string) => ({ loginHint }));
export const onLoadingSet = action('onLoadingSet', (value?: boolean) => ({ value }));
export const onSwitchAccount = action('onSwitchAccount');
